var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSpaces(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cvzr1zozpa",
    d: "M14.5 1c5.247 0 9.5 4.253 9.5 9.5S19.747 20 14.5 20c-.248 0-.493-.01-.736-.028C12.502 21.802 10.391 23 8 23c-3.866 0-7-3.134-7-7 0-2.807 1.652-5.228 4.037-6.344C5.464 4.805 9.537 1 14.5 1zM5.106 11.923l-.026.018C3.82 12.849 3 14.329 3 16c0 2.761 2.239 5 5 5 1.384 0 2.636-.562 3.541-1.47-3.362-1.1-5.897-4.027-6.435-7.607zM14.5 3c-3.647 0-6.687 2.604-7.36 6.054C7.42 9.018 7.707 9 8 9c3.866 0 7 3.134 7 7 0 .694-.101 1.365-.29 1.998C18.756 17.886 22 14.572 22 10.5 22 6.358 18.642 3 14.5 3zM8 11c-.334 0-.66.033-.976.095.255 3.248 2.577 5.913 5.65 6.681.211-.552.326-1.15.326-1.776 0-2.761-2.239-5-5-5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.000000, -204.000000) translate(0.000000, 192.000000) translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1xur3iimab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cvzr1zozpa"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.87,
    mask: "url(#1xur3iimab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpaces);
export default __webpack_public_path__ + "static/media/icon-spaces.e6150a1a8d1d75607c96a628c8e30cba.svg";
export { ForwardRef as ReactComponent };